import { render, staticRenderFns } from "./bargain.vue?vue&type=template&id=1834b303&"
import script from "./bargain.vue?vue&type=script&lang=ts&"
export * from "./bargain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports